// src/menu/sections/caMenu.ts
import type { AppMenuEntry } from "../types";

export const AUTOMATION_MENU: AppMenuEntry = {
  type: "group",
  key: "automation",
  label: "Automation",
  children: [
    {
      key: "certificate_automations",
      label: "Certificate Automations",
      path: "/certificate_automations",
      resource: "certificate_automations",
      icon: "control",
    },
    {
      key: "automation_runs",
      label: "Automation Runs",
      path: "/automation_runs",
      resource: "automation_runs",
      icon: "securityscan",
    },
    {
      key: "automation_target_types",
      label: "Automation Target Types",
      path: "/automation_target_types",
      resource: "automation_target_types",
      icon: "code",
    },
  ],
};
